export const closestLvzInfoSelector = ({closestLvzInfo}) => closestLvzInfo